import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import VersionChecker from "components/VersionChecker";
import Header from 'components/Header';
import Login from "screens/Login";
import AccountProfile from "screens/AccountProfile";
import Home from "screens/Home";
import Parking from "screens/Parking";
import Bookings from "screens/Bookings";
import CreateBooking from "screens/CreateBooking";
import Staff from "screens/Staff";
import ForgotPassword from "screens/ForgotPassword";
import ResetPassword from "screens/ResetPassword";
import SetupAccount from "screens/SetupAccount";
import Reports from "screens/Reports";
import GroupDetails from "screens/GroupDetails";
import GroupCheckIn from "screens/GroupCheckIn";
import TenantDetails from "screens/TenantDetails";
import StaffDetails from "screens/StaffDetails";
import Settings from "screens/Settings";
import Cafe from "screens/Cafe";
import CafePanel from "screens/CafePanel";
import Rooms from "screens/Rooms";
import RoomDetails from "screens/RoomDetails";
import RoomChange from "screens/RoomChange";
import RoomTypeDetails from "screens/RoomTypeDetails";
import Communications from "screens/Communications";
import SearchResults from "screens/SearchResults";
import NotFoundScreen from "screens/NotFoundScreen";
import Cookies from "js-cookie";

const App = () => {
  const validToken = Cookies.get("token");
  const location = useLocation();
  if (
    location.pathname !== "/login" &&
    location.pathname !== "/forgetPassword"
  ) {
    localStorage.setItem("previousPath", location.pathname);
  }

  return (
    <>
      <VersionChecker />
      {!!validToken ? (
        <>
          <Header />
          <Routes>
            <Route path="/login" element={<Navigate to={localStorage.getItem("previousPath") || "/floor"} replace />} />
            <Route path="/reset" element={<ResetPassword />} />
            <Route path="/setup" element={<SetupAccount />} />
            <Route path="/" element={<Navigate to="/floor" replace />} />
            <Route path="/profile" element={<AccountProfile />} />
            <Route path="/floor/*" element={<Home />} />
            <Route path="/parking" element={<Parking />} />
            <Route path="/bookings" element={<Bookings />} />
            <Route path="/staff" element={<Staff />} />
            <Route path="/reports/*" element={<Reports />} />
            <Route path="/settings/*" element={<Settings />} />
            <Route path="/cafe" element={<Cafe />} />
            <Route path="/create-booking" element={<CreateBooking />} />
            <Route path="/rooms" element={<Rooms />} />
            <Route
              path="/room-change/:bookingId"
              element={<RoomChange />}
            />
            <Route
              path="/room-details/:roomNumber"
              element={<RoomDetails />}
            />
            <Route
              path="/booking-details/:groupId"
              element={<GroupDetails />}
            />
            <Route
              path="/cafe-panel/:groupId"
              element={<CafePanel />}
            />
            <Route path="/group-check-in/*" element={<GroupCheckIn />} />
            <Route
              path="/staff-details/:staffId"
              element={<StaffDetails />}
            />
            <Route
              path="/tenant-details/:tenantId"
              element={<TenantDetails />}
            />
            <Route
              path="/room-type-details/:roomTypeId"
              element={<RoomTypeDetails />}
            />
            <Route
              path="/tenant-communications/:tenantId"              
              element={<Communications />}
            />
            <Route
              path="/staff-communications/:staffId"
              element={<Communications />}
            />
            <Route path="/search-results" element={<SearchResults />} />
            <Route path="*" element={<NotFoundScreen />} />
          </Routes>
        </>
      ) : (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route path="/setup" element={<SetupAccount />} />
          <Route path="*" element={<Navigate to="/login" replace/>} />
        </Routes>
      )}
    </>
  );
};

export default App;
